import angular from "angular"

/**
 * A separate module used by the ngtemplate-loader to specify templates.
 * This module should be refreshed after lazy-loading.
 */
export const TemplateCacheModule = angular
    .module("apex.core.templateCache", [])
    .name;
